import { FC } from "react"
import { OdResourcePageProps } from "~/types/resource"
import { Box } from "@mui/material"
import EncryptionKeyList from "./EncryptionKeyList"
import TokenValidationKeys from "./TokenValidationKeys"
import usePermitGuard from "~/authProvider/usePermitGuard"
import { KEY_MANAGEMENT } from "~/constants"


const KeyContent: FC<OdResourcePageProps> = (props) => {
  usePermitGuard([[KEY_MANAGEMENT]]) // ??
  return (
    <Box>
      <EncryptionKeyList />
      <Box sx={{ mt: 4 }}>
        <TokenValidationKeys />
      </Box>
    </Box>
  )
}

export default KeyContent;
